// ***********************************************************************************************************************************************************//
//                                              Document                                                                                                      //
// I.Param                                                                                                                                                    //
//   -  arrImageHash // ex : [{id: "90661b11f434ff64f8b75cf0bc85fa542db14053", matrix: Array(4)}, {...}]                                                      //
//   -  arrImage     // ex : ["http://13.231.204.92/image/v0.0.9/redirect/0bc85fa542db14053?type=medium","..."]                                               //
//   -  matrixImage  // ex : [[-1, 0, 0, 1], [-1, 0, 0, -1], [1, 0, 0, 1]]                                                                                    //
//   - arrRotate     // ex : [180, 90, -270]                                                                                                                  //
// II. Use                                                                                                                                                    //
//    LOAD IMAGE                                                                                                                                              //
//   - <img [ngStyle]="matrixServices.arrStyleImage[i]" (load)="matrixServices.loadSizeImage((#imageWidthHeight),                                             //
//       (#frameWidthHeight),  i, matrixImage, arrImage, arrImageHash)" />                                                                                    //
//   ROTATE IMAGE                                                                                                                                             //
//   Pass (#imageWidthHeight),(#frameWidthHeight), ActionType                                                                                                 //
// ex ActionType: 1. horizontal Flip -> 'horizontalFlip', 2. vertical Flip -> 'verticalFlip', 3. right Rotate -> 'rightRotate', 4. left Rotate -> 'leftRotate'//
//                                                                                                                                                            //
//   (click)="matrixServices.defaultRotate(i, matrixServices.arrRotate[i], (#imageWidthHeight),(#frameWidthHeight),                                           //
//             ActionType, matrixServices.arrFlip[i]['horizontalFlip'], matrixServices.arrFlip[i]['verticalFlip'])"                                           //
//   REMOVE IMAGE                                                                                                                                             //
//   - <button (click)="matrixServices.removePhoto(i)" />                                                                                                     //
//   DOWNLOAD IMAGE                                                                                                                                           //
//   - <button (click)="matrixServices.loadDrawImage(i, (#download), (#myCanvas), matrixServices.arrImageHash[i]['id'])" />                                   //
//   - <a (click)="matrixServices.downloadImage(i, download1, myCanvas1, matrixServices.arrImageHash[i]['id'])" #download style="display: none"></a>          //
//   Tag canvas, Take it outside image                                                                                                                        //
//   - <canvas #myCanvas1 width="" height="" style="border:1px solid #d3d3d3; display: none"></canvas>                                                        //
// III.                                                                                                                                                       //
// - No matrix user function loadMatrixImageList(container, imageId)                                                                                          //
// ***********************************************************************************************************************************************************//

import { Injectable } from '@angular/core'
import { notification } from 'onsenui'
import { AuthService } from '../auth.services'
import { RestServices } from '../rest.services'
import { StateServices } from '../state.services'
import { imageStatusUrl } from '@helpers/common'

@Injectable()

export class MatrixServices {
    imageHeightDefaultN1
    imageHeightDefaultN4
    imageWidthDefaultN3
    imageWidthDefaultN2
    styleRotate
    arrStyleImage: any = [0, 0, 0, 0, 0, 0,0, 0, 0, 0, 0, 0]
    arrRotate = []
    horizontalFlip = 1
    verticalFlip = 1
    arrFlip = []
    arrLoading = []
    loading = false
    animationDuration
    matrixImage = []
    dXdYMatrixCanvas = []

    arrImageHash = []
    oldImage = []
    arrImage = []
    styleMatrix = []
    en = {}

    constructor(private authData: AuthService, private restApi: RestServices, private stateServices: StateServices) {
    }

    // load image
    loadSizeImage(imageDOM, containerDOM, indexAppear, matrixImage, arrImage, arrImageHash) {
        // this.arrStyleImage = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        this.matrixImage = matrixImage
        this.arrImageHash = arrImageHash
        this.oldImage = this.arrImage
        this.arrImage = arrImage
        // isset arr image matrix in server
        if (imageDOM) {
            if (this.matrixImage[indexAppear]) {
                const heightN1 = containerDOM.offsetHeight / imageDOM.clientHeight
                const widthN1 = containerDOM.offsetWidth / imageDOM.clientWidth
                const heightN2 = containerDOM.offsetHeight / imageDOM.clientWidth
                const widthN2 = containerDOM.offsetWidth / imageDOM.clientHeight
                const n1 = (heightN1 > widthN1 ? widthN1 : heightN1) * Math.abs(this.matrixImage[indexAppear][0]) // n1
                const n2 = (heightN2 > widthN2 ? widthN2 : heightN2) * (this.matrixImage[indexAppear][1]) // n2
                const n3 = (heightN2 > widthN2 ? widthN2 : heightN2) * (this.matrixImage[indexAppear][2]) // n3
                 const n4 = (heightN1 > widthN1 ? widthN1 : heightN1) * Math.abs(this.matrixImage[indexAppear][3]) // n4
                const n5 = (containerDOM.offsetWidth - imageDOM.clientWidth) / 2
                const n6 = (containerDOM.offsetHeight - imageDOM.clientHeight) / 2
                this.styleRotate = {
                    'transform': 'matrix(' + n1 + ', ' + n2 + ', ' + n3 + ', ' + n4 + ', ' + n5 + ', ' + n6 + ')',
                }
                this.arrStyleImage.splice(indexAppear, 1, this.styleRotate)
                // compare matrix db
                this.compareArrMatrix([n1 / Math.abs(n1) || 0, n2 / Math.abs(n2) || 0, n3 / Math.abs(n3) || 0, n4 / Math.abs(n4) || 0], indexAppear)
                this.dXdYMatrixCanvas.push(0)
                this.arrLoading.push(0)
            } else {
                const n1 = (containerDOM.offsetHeight / imageDOM.clientHeight) // n1
                const n3 = 0 // n3
                const n2 = 0 // n2
                const n4 = (containerDOM.offsetHeight / imageDOM.clientHeight) // n4
                const n5 = (containerDOM.offsetWidth - imageDOM.clientWidth) / 2
                const n6 = (containerDOM.offsetHeight - imageDOM.clientHeight) / 2
                this.styleRotate = {
                    'transform': 'matrix(' + n1 + ', ' + n2 + ', ' + n3 + ', ' + n4 + ', ' + n5 + ', ' + n6 + ')',
                }
                this.arrStyleImage.splice(indexAppear, 1, this.styleRotate)
                this.arrRotate.push(0)
                this.dXdYMatrixCanvas.push(0)
                const arrFlip = {
                    'horizontalFlip': 1, 'verticalFlip': 1,
                }
                this.arrFlip.push(arrFlip)
            }
        }
        // this.loadDrawImage(i, myCanvas);
    }

    // load image
    loadSizeImageDental(imageDOM, containerDOM, indexAppear, matrixImage, arrImage, arrImageHash) {
        this.matrixImage = matrixImage
        this.arrImageHash = arrImageHash
        this.oldImage = this.arrImage
        this.arrImage = arrImage
        // isset arr image matrix in server
        if (imageDOM) {
            if (this.matrixImage[indexAppear]) {
                const heightN1 = containerDOM.offsetHeight / imageDOM.clientHeight
                const widthN1 = containerDOM.offsetWidth / imageDOM.clientWidth
                const heightN2 = containerDOM.offsetHeight / imageDOM.clientWidth
                const widthN2 = containerDOM.offsetWidth / imageDOM.clientHeight
                const n1 = (heightN1 > widthN1 ? widthN1 : heightN1) * (this.matrixImage[indexAppear][0]) // n1
                const n2 = (heightN2 > widthN2 ? widthN2 : heightN2) * (this.matrixImage[indexAppear][1]) // n2
                const n3 = (heightN2 > widthN2 ? widthN2 : heightN2) * (this.matrixImage[indexAppear][2]) // n3
                const n4 = (heightN1 > widthN1 ? widthN1 : heightN1) * (this.matrixImage[indexAppear][3]) // n4
                const n5 = (containerDOM.offsetWidth - imageDOM.clientWidth) / 2
                const n6 = (containerDOM.offsetHeight - imageDOM.clientHeight) / 2
                this.styleRotate = {
                    'transform': 'matrix(' + n1 + ', ' + n2 + ', ' + n3 + ', ' + n4 + ', ' + n5 + ', ' + n6 + ')',
                }
                this.arrStyleImage.splice(indexAppear, 1, this.styleRotate)
                // compare matrix db
                this.compareArrMatrix([n1 / Math.abs(n1) || 0, n2 / Math.abs(n2) || 0, n3 / Math.abs(n3) || 0, n4 / Math.abs(n4) || 0], indexAppear)
                this.dXdYMatrixCanvas.push(0)
                this.arrLoading.push(0)
            } else {
                const n1 = (containerDOM.offsetHeight / imageDOM.clientHeight) // n1
                const n3 = 0 // n3
                const n2 = 0 // n2
                const n4 = (containerDOM.offsetHeight / imageDOM.clientHeight) // n4
                const n5 = (containerDOM.offsetWidth - imageDOM.clientWidth) / 2
                const n6 = (containerDOM.offsetHeight - imageDOM.clientHeight) / 2
                this.styleRotate = {
                    'transform': 'matrix(' + n1 + ', ' + n2 + ', ' + n3 + ', ' + n4 + ', ' + n5 + ', ' + n6 + ')',
                }
                this.arrStyleImage.push(this.styleRotate)
                this.arrRotate.push(0)
                this.dXdYMatrixCanvas.push(0)
                const arrFlip = {
                    'horizontalFlip': 1, 'verticalFlip': 1,
                }
                this.arrFlip.push(arrFlip)
            }
        }

        // this.loadDrawImage(i, myCanvas);
    }

    // compare matrix
    compareArrMatrix(matrix, i) {
        this.arrRotate.push(0)
        this.arrFlip.push(0)
        switch (matrix.join(' ')) {
            case '0 -1 1 0':
                this.arrRotate.splice(i, 1, -90)
                const arrflip90 = {
                    'horizontalFlip': 1, 'verticalFlip': 1,
                }
                // update arr flip
                this.arrFlip.splice(i, 1, arrflip90)
                break
            case '-1 0 0 -1':
                this.arrRotate.splice(i, 1, -180)
                const arrflip180 = {
                    'horizontalFlip': 1, 'verticalFlip': 1,
                }
                // update arr flip
                this.arrFlip.splice(i, 1, arrflip180)
                break
            case '0 1 -1 0':
                // this.coordinates = -270;
                this.arrRotate.splice(i, 1, -270)
                const arrflip270 = {
                    'horizontalFlip': 1, 'verticalFlip': 1,
                }
                // update arr flip
                this.arrFlip.splice(i, 1, arrflip270)
                break
            case '0 -1 -1 0':
                this.arrRotate.splice(i, 1, -270)
                const arrflip = {
                    'horizontalFlip': -1, 'verticalFlip': 1,
                }
                // update arr flip
                this.arrFlip.splice(i, 1, arrflip)
                break
            case '1 0 0 -1':
                // this.coordinates = -180;
                this.arrRotate.splice(i, 1, -180)
                const arrflip1 = {
                    'horizontalFlip': -1, 'verticalFlip': 1,
                }
                // update arr flip
                this.arrFlip.splice(i, 1, arrflip1)
                break
            case '0 1 1 0':
                // this.coordinates = -270;
                this.arrRotate.splice(i, 1, -90)
                const arrflip2 = {
                    'horizontalFlip': -1, 'verticalFlip': 1,
                }
                // update arr flip
                this.arrFlip.splice(i, 1, arrflip2)
                break
            case '-1 0 0 1':
                // this.coordinates = 0;
                this.arrRotate.splice(i, 1, 0)
                const arrflip3 = {
                    'horizontalFlip': -1, 'verticalFlip': 1,
                }
                // update arr flip
                this.arrFlip.splice(i, 1, arrflip3)
                break
            default:
                // this.coordinates = 0;
                this.arrRotate.splice(i, 1, 0)
                const arrflip4 = {
                    'horizontalFlip': 1, 'verticalFlip': 1,
                }
                // update arr fli
                this.arrFlip.splice(i, 1, arrflip4)
        }
    }

    // rotate image
    defaultRotate(i, coordinates: number, img, container, keyRotate, horizontalFlip, verticalFlip) {
        // update Rotate (arrRotate)
        if (keyRotate !== 'horizontalFlip' && keyRotate !== 'verticalFlip') {
            if (keyRotate === 'leftRotate') {
                const coorSum = Number(coordinates) - 90
                if (coordinates > -270) {
                    this.arrRotate.splice(i, 1, coorSum)
                } else {
                    this.arrRotate.splice(i, 1, 0)
                }
            }

            if (keyRotate === 'rightRotate') {
                const coorSum = Number(coordinates) + 90
                if (coordinates < 270) {
                    this.arrRotate.splice(i, 1, coorSum)
                } else {
                    this.arrRotate.splice(i, 1, 0)
                }
            }
        }

        // click flip
        if (keyRotate === 'horizontalFlip') {
            if ((this.arrRotate[i] === -90 || this.arrRotate[i] === -270 || this.arrRotate[i] === 90 || this.arrRotate[i] === 270)) {
                this.verticalFlip = (verticalFlip === -1) ? 1 : -1
                this.horizontalFlip = horizontalFlip
            } else {
                this.horizontalFlip = (horizontalFlip === -1) ? 1 : -1
                this.verticalFlip = verticalFlip
            }
        } else if (keyRotate === 'verticalFlip') {
            if ((this.arrRotate[i] === -90 || this.arrRotate[i] === -270 || this.arrRotate[i] === 90 || this.arrRotate[i] === 270)) {
                this.horizontalFlip = (horizontalFlip === -1) ? 1 : -1
                this.verticalFlip = verticalFlip
            } else {
                this.verticalFlip = (verticalFlip === -1) ? 1 : -1
                this.horizontalFlip = horizontalFlip
            }
        } else {
            this.horizontalFlip = horizontalFlip
            this.verticalFlip = verticalFlip
        }
        // update arr flip
        const arrflip = {
            'horizontalFlip': this.horizontalFlip, 'verticalFlip': this.verticalFlip,
        }
        this.arrFlip.splice(i, 1, arrflip)

        this.imageHeightDefaultN1 = this.arrFlip[i]['horizontalFlip'] * img.clientHeight
        this.imageWidthDefaultN2 = this.arrFlip[i]['horizontalFlip'] * img.clientWidth
        this.imageWidthDefaultN3 = this.arrFlip[i]['verticalFlip'] * img.clientWidth
        this.imageHeightDefaultN4 = this.arrFlip[i]['verticalFlip'] * img.clientHeight
        const n5 = (container.offsetWidth - img.clientWidth) / 2
        const n6 = (container.offsetHeight - img.clientHeight) / 2
        const n1 = container.offsetHeight / this.imageHeightDefaultN1
        const n3 = container.offsetHeight / this.imageWidthDefaultN3 // n3
        const n2 = container.offsetHeight / this.imageWidthDefaultN2 // n4
        const n4 = container.offsetHeight / this.imageHeightDefaultN4 // n4
        // arr coordinates
        this.coordinatesImage(this.arrRotate[i], i, n1, n2, n3, n4, n5, n6)
    }

    // function coordinates
    coordinatesImage(coorSum, i, n1, n2, n3, n4, n5, n6) {
        switch (coorSum) {
            case -90:
                const styleRotate_90 = {
                    'transform': 'matrix(0, ' + -n2 + ', ' + n3 + ', 0, ' + n5 + ', ' + n6 + ')',
                }
                this.arrStyleImage.splice(i, 1, styleRotate_90)
                const matrix = [0, -n2 / Math.abs(n2), n3 / Math.abs(n3), 0]
                this.matrixImage.splice(i, 1, matrix)
                this.editMatrixImage(i)
                break
            case -180:
                const styleRotate_180 = {
                    'transform': 'matrix(' + -n1 + ', 0, 0, ' + -n4 + ',' + n5 + ',' + n6 + ')',
                }
                this.arrStyleImage.splice(i, 1, styleRotate_180)
                const matrix_180 = [-n1 / Math.abs(n1), 0, 0, -n4 / Math.abs(n4)]
                this.matrixImage.splice(i, 1, matrix_180)
                this.editMatrixImage(i)
                break
            case -270:
                const styleRotate_270 = {
                    'transform': 'matrix(0, ' + n2 + ', ' + -n3 + ', 0, ' + n5 + ', ' + n6 + ')',
                }
                this.arrStyleImage.splice(i, 1, styleRotate_270)
                const matrix_270 = [0, n2 / Math.abs(n2), -n3 / Math.abs(n3), 0]
                this.matrixImage.splice(i, 1, matrix_270)
                this.editMatrixImage(i)
                break
            case 90:
                const styleRotate_090 = {
                    'transform': 'matrix(0, ' + n2 + ', ' + -n3 + ', 0, ' + n5 + ', ' + n6 + ')',
                }
                this.arrStyleImage.splice(i, 1, styleRotate_090)
                const matrix90 = [0, n2 / Math.abs(n2), -n3 / Math.abs(n3), 0]
                this.matrixImage.splice(i, 1, matrix90)
                this.editMatrixImage(i)
                break
            case 180:
                const styleRotate_0180 = {
                    'transform': 'matrix(' + -n1 + ', 0, 0, ' + -n4 + ',' + n5 + ',' + n6 + ')',
                }
                this.arrStyleImage.splice(i, 1, styleRotate_0180)
                const matrix180 = [-n1 / Math.abs(n1), 0, 0, -n4 / Math.abs(n4)]
                this.matrixImage.splice(i, 1, matrix180)
                this.editMatrixImage(i)
                break
            case 270:
                const styleRotate_0270 = {
                    'transform': 'matrix(0, ' + -n2 + ', ' + n3 + ', 0, ' + n5 + ', ' + n6 + ')',
                }
                this.arrStyleImage.splice(i, 1, styleRotate_0270)
                const matrix270 = [0, -n2 / Math.abs(n2), (n3 / Math.abs(n3)), 0]
                this.matrixImage.splice(i, 1, matrix270)
                this.editMatrixImage(i)
                break
            default:
                const styleRotate_0 = {
                    'transform': 'matrix(' + n1 + ', 0, 0, ' + n4 + ',' + n5 + ',' + n6 + ')',
                }
                this.arrStyleImage.splice(i, 1, styleRotate_0)
                const matrixdefault = [(n1 / Math.abs(n1)), 0, 0, (n4 / Math.abs(n4))]
                this.matrixImage.splice(i, 1, matrixdefault)
                this.editMatrixImage(i)
        }
    }


    // update maxtrix save database
    editMatrixImage(i) {
        if (this.arrImageHash[i]) {
            const idImage = {
                id: this.arrImageHash[i] ? this.arrImageHash[i]['id'] : '',
                matrix: (this.matrixImage[i]) ? this.matrixImage[i] : [1, 0, 0, 1],
            }
            this.arrImageHash.splice(i, 1, idImage)
            const tabName = this.stateServices.getTabName()
            if (tabName != '') {
                const arrEmit: any = {}
                arrEmit[tabName] = this.arrImageHash
                arrEmit['index'] = i
                this.stateServices.emitChangeHash(arrEmit)
            }
        }
    }


    removePhoto(index) {
        this.arrImage.splice(index, 1, undefined)
        this.arrImageHash.splice(index, 1, undefined)
        this.arrLoading.splice(index, 1, false)
        this.arrStyleImage.splice(index, 1, undefined)
        this.arrFlip.splice(index, 1, undefined)
        this.arrRotate.splice(index, 1, 0)
    }

    resetMatrix() {
        this.arrImage = []
        this.oldImage = []
        this.arrImageHash = []
        this.arrLoading = []
        this.arrStyleImage = []
        this.arrFlip = []
        this.arrRotate = []
        this.dXdYMatrixCanvas = []
    }

    // ********************************************** download image
    loadDrawImage(i, download, myCanvas, id) {
        this.initArrloading(i)
        this.animationDuration = 2000
        if (!this.matrixImage[i]) {
            this.matrixImage[i] = [1, 0, 0, 1]
        }
        this.matrixCanvas(this.matrixImage[i], i)
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_get(imageStatusUrl + '/' + id, tokenReNew).subscribe(success => {
                this.getBase64FromImageUrl(success['url'], myCanvas, download, this.matrixImage[i], this.dXdYMatrixCanvas[i], i, id)
            })
        })
    }

    changeLanguage() {
        return this.en = this.authData.showLang(true)
    }

    initArrloading(countIndex) {
        if (countIndex > this.arrLoading.length) {
            this.arrLoading = []
            for (let index = 0; index < countIndex; index++) {
                this.arrLoading.push(false)
            }
            this.arrLoading.push(true)
        } else {
            this.arrLoading.splice(countIndex, 1, true)
        }
    }

    getBase64FromImageUrl(URL, myCanvas, download, matrix, dxdy, index, id) {
        this.changeLanguage()

        const img = new Image()
        img.setAttribute('crossOrigin', 'anonymous')
        const thi = this
        img.onload = function() {
            myCanvas.width = (matrix[2] !== 0 || matrix[1] !== 0) ? img.height : img.width
            myCanvas.height = (matrix[2] !== 0 || matrix[1] !== 0) ? img.width : img.height
            const ctx = myCanvas.getContext('2d')
            ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], dxdy[0] * myCanvas.width, dxdy[1] * myCanvas.height)
            ctx.drawImage(this, 0, 0)
            setTimeout(() => {
                // this.loading = false;
                thi.arrLoading.splice(index, 1, false)
            }, 500)
            notification.confirm({
                message: thi.en['download-notice'],
                title: `<b>${ thi.en['download'] }</b>`,
                buttonLabels: ['OK'],
                callback: i => {
                    if (i === 0) {  // here this is not cancelled.  1 is correct.
                        myCanvas.toBlob(function(blob) {
                            download.href = window.URL.createObjectURL(blob)
                            download.download = id
                            download.click()
                        }, 'image/jpeg')

                    }
                },
            })
        }
        img.src = URL
    }

    downloadImage(i, download, myCanvas, id) {
        this.arrLoading.splice(i, 1, false)
    }

    matrixCanvas(matrix, i) {
        switch (matrix.join(' ')) {
            case '0 1 -1 0':
                const arrdxdyMatrix1 = [1, 0]
                this.dXdYMatrixCanvas.splice(i, 1, arrdxdyMatrix1)
                break
            case '0 -1 1 0':
                const arrdxdyMatrix2 = [0, 1]
                this.dXdYMatrixCanvas.splice(i, 1, arrdxdyMatrix2)
                break
            case '0 -1 -1 0':
                const arrdxdyMatrix3 = [1, 1]
                this.dXdYMatrixCanvas.splice(i, 1, arrdxdyMatrix3)
                break
            case '1 0 0 -1':
                const arrdxdyMatrix4 = [0, 1]
                this.dXdYMatrixCanvas.splice(i, 1, arrdxdyMatrix4)
                break
            case '-1 0 0 1':
                const arrdxdyMatrix5 = [1, 0]
                this.dXdYMatrixCanvas.splice(i, 1, arrdxdyMatrix5)
                break
            case '-1 0 0 -1':
                const arrdxdyMatrix6 = [1, 1]
                this.dXdYMatrixCanvas.splice(i, 1, arrdxdyMatrix6)
                break
            default:
                const arrdxdyMatrix = [0, 0]
                this.dXdYMatrixCanvas.splice(i, 1, arrdxdyMatrix)
                break
        }
    }

    // ********************************************** end download image

    sortImage(index, action) {
        if (action === 'up') {
            const br1 = this.arrImage[index - 1]
            const br2 = this.arrImage[index]
            const arrImageHash_1 = this.arrImageHash[index - 1]
            const arrImageHash = this.arrImageHash[index]
            const arrStyleImage_1 = this.arrStyleImage[index - 1]
            const arrStyleImage = this.arrStyleImage[index]
            const arrRotate_1 = this.arrRotate[index - 1]
            const arrRotate = this.arrRotate[index]
            this.arrStyleImage.splice(index - 1, 2, arrStyleImage, arrStyleImage_1) // arr style matrix show image
            this.arrImage.splice(index - 1, 2, br2, br1) // arr show brower
            this.arrImageHash.splice(index - 1, 2, arrImageHash, arrImageHash_1) // arr insert database
            this.arrRotate.splice(index - 1, 2, arrRotate, arrRotate_1) // arr insert database
        } else if (action === 'down') {
            const br1 = this.arrImage[index]
            const br2 = this.arrImage[index + 1]
            const arrImageHash_1 = this.arrImageHash[index + 1]
            const arrImageHash = this.arrImageHash[index]
            const arrStyleImage_1 = this.arrStyleImage[index + 1]
            const arrStyleImage = this.arrStyleImage[index]
            const arrRotate_1 = this.arrRotate[index + 1]
            const arrRotate = this.arrRotate[index]
            this.arrImage.splice(index, 2, br2, br1)
            this.arrImageHash.splice(index, 2, arrImageHash_1, arrImageHash)
            this.arrStyleImage.splice(index, 2, arrStyleImage_1, arrStyleImage) // arr style matrix show image
            this.arrRotate.splice(index, 2, arrRotate_1, arrRotate) // arr style matrix show image
        }
    }

    loadMatrixImageList(container = null, img = null, matrix = null, style = null) {
        let styleMatrix
        if (container && img && matrix) {
            const n1 = (container.offsetHeight / img.clientHeight) * (matrix[0]) // n1
            const n2 = (container.offsetHeight / img.clientWidth) * (matrix[1]) // n2
            const n3 = (container.offsetHeight / img.clientWidth) * (matrix[2]) // n3
            const n4 = (container.offsetHeight / img.clientHeight) * (matrix[3]) // n4
            const n5 = (container.offsetWidth - img.clientWidth) / 2
            const n6 = (container.offsetHeight - img.clientHeight) / 2
            if(style){
                styleMatrix = { 'transform': 'matrix(' + n1 + ', ' + n2 + ', ' + n3 + ', ' + n4 + ',' + n5 + ',' + n6 + ') rotate(' + style.rotate + 'deg) scaleX(' + style.scaleX + ') scaleY(' + style.scaleY + ')' }
            } else {
                styleMatrix = { 'transform': 'matrix(' + n1 + ', ' + n2 + ', ' + n3 + ', ' + n4 + ',' + n5 + ',' + n6 + ')' }
            }
        } else {
            if(style){
                styleMatrix = { 'transform': 'matrix(' + (container.offsetHeight / img.clientHeight) + ', 0, 0, ' + (container.offsetHeight / img.clientHeight) + ', ' + (container.offsetWidth - img.clientWidth) / 2 + ', ' + (container.offsetHeight - img.clientHeight) / 2 + ') rotate(' + style.rotate + 'deg) scaleX(' + style.scaleX + ') scaleY(' + style.scaleY + ')' }
            } else {
                styleMatrix = { 'transform': 'matrix(' + (container.offsetHeight / img.clientHeight) + ', 0, 0, ' + (container.offsetHeight / img.clientHeight) + ', ' + (container.offsetWidth - img.clientWidth) / 2 + ', ' + (container.offsetHeight - img.clientHeight) / 2 + ')' }
            }
        }
        return styleMatrix
    }

    loadMatrixImageHorizontalList(wrapImage = null, currentImage = null, matrix = null) {
        let styleMatrix
        if (wrapImage && currentImage && matrix) {
            const widthRatio = wrapImage.offsetWidth / currentImage.clientWidth
            const heightRatio = wrapImage.offsetHeight / currentImage.clientHeight
            let ratioMin = Math.min(widthRatio, heightRatio)
            const n1 = ratioMin * (matrix[0]) // n1
            const n2 = ratioMin * (matrix[1]) // n2
            const n3 = ratioMin * (matrix[2]) // n3
            const n4 = ratioMin * (matrix[3]) // n4
            const n5 = (wrapImage.offsetWidth - currentImage.clientWidth) / 2
            const n6 = (wrapImage.offsetHeight - currentImage.clientHeight) / 2

            styleMatrix = {
                'transform': 'matrix(' + n1 + ', ' + n2 + ', ' + n3 + ', ' + n4 + ',' + 0 + ',' + 0 + ')',
            }
        } else {
            styleMatrix = {
                'transform': 'matrix(' + (wrapImage.offsetHeight / currentImage.clientHeight) + ', 0, 0, ' + (wrapImage.offsetHeight / currentImage.clientHeight)
                    + ', 0, 0)',
            }
        }
        this.fitImage(wrapImage, currentImage, styleMatrix)
        return styleMatrix
    }

    private fitImage(imgWrapper, img, styleMatrix) {
        if (imgWrapper && img.clientWidth) {
            img.style.transform = styleMatrix.transform
            setTimeout(() => {
                if (parseInt(img.getBoundingClientRect().height, 10) > imgWrapper.clientHeight) {
                    imgWrapper.style.height = img.getBoundingClientRect().height + 'px'
                } else if (parseInt(img.getBoundingClientRect().width, 10) > imgWrapper.clientWidth) {
                    this.loadMatrixImageHorizontalList(imgWrapper, img, [1, 0, 0, 1])
                }
            }, 50)
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/image/matrix.services.ts